module.exports = __webpack_public_path__ + "static/img/news2.2fc3b7d9.png";